import { render, staticRenderFns } from "./UnityEconomyConfig.vue?vue&type=template&id=67acc73c&scoped=true&"
import script from "./UnityEconomyConfig.vue?vue&type=script&lang=js&"
export * from "./UnityEconomyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67acc73c",
  null
  
)

export default component.exports